import React from 'react';
import styled from 'styled-components';
import {Button, Container, Grid} from '@material-ui/core';
import BackButton from '../Shared/BackButton';
import Layout from '../Shared/Layout';
import Dropzone from '../Shared/Dropzone';
import GetApp from "@material-ui/icons/GetApp";
import {Inertia} from "@inertiajs/inertia";
import { Trans } from "../utils/i18n";

export default function QueueImport({ import_template, returnUrl,}) {
    return (
      <Wrapper>
          <Container maxWidth="lg">
              <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12}>
                      <BackButton label="Queues" href={returnUrl || route('queue.index')} />
                  </Grid>
                  <Grid item xs={12}>
                      <div style={{display: "flex", justifyContent: 'space-between', alignItems: 'center'}}>
                          <h1><Trans i18nKey="queueImport.importQueues">Import Queues</Trans></h1>
                          <Button
                              variant="contained"
                              color="primary"
                              endIcon={<GetApp><Trans i18nKey="queueImport.send">send</Trans></GetApp>}
                              target={'_blank'}
                              href={import_template}
                          >
                              <Trans i18nKey="queueImport.excelTemplate">EXCEL Template</Trans>
                          </Button>
                      </div>
                  </Grid>
              </Grid>
              <Dropzone />
          </Container>
      </Wrapper>
    );
};

const Wrapper = styled.div`
`;

QueueImport.layout = page => <Layout children={page} />;
